/* enemy-ticker.js — duplica el contenido las veces necesarias para que el loop
   siempre sea continuo, sin importar el ancho de pantalla ni el largo del texto. */
(function () {
  'use strict';

  function fillTicker(ticker) {
    const track = ticker.querySelector('.ec-ticker__track');
    if (!track) return;

    if (!ticker.dataset.originalHtml) {
      ticker.dataset.originalHtml = track.innerHTML;
    }
    const original = ticker.dataset.originalHtml;

    // Reconstruye siempre desde el contenido original para poder recalcular
    // en un resize sin ir acumulando copias de más.
    track.innerHTML = original + original; // base: 2 copias (mínimo para el -50%)

    let guard = 0;
    // Sigue agregando de a 2 copias (mantiene el total PAR, clave para que
    // translateX(-50%) caiga siempre justo en el borde de una repetición)
    // hasta que el track sea al menos el doble de ancho que el contenedor.
    while (track.scrollWidth < ticker.clientWidth * 2 && guard < 20) {
      track.innerHTML += original + original;
      guard++;
    }
  }

  function init() {
    document.querySelectorAll('.ec-ticker').forEach(fillTicker);
  }

  document.addEventListener('DOMContentLoaded', init);

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(init, 200);
  });
})();
